import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import CountryCode from "../../../countryCode";
import DialogNotice from "../../../dialog";
import { styles } from "./styles";

/*---Mui---*/
// import ListCustomer from '../../listCustomer';
/*---styles---*/
function Transition(props) {
  return <Slide direction="down" {...props} />;
}
class AddOwnerModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      service: "",
      mobilePhone: "",
      countryCode: this.props.defaultCountryCode || "+84",
      modalContent: "",
      showModal: false,
      agreeModal: "",
      ownerData: {},
      action: "",
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      this.setState({ countryCode: nextProps.defaultCountryCode });
    }
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  findUserforAdmin = async () => {
    let check = await this.props.userDispatch.findUserforAdmin({
      mobilePhone: this.state.mobilePhone,
      countryCode: this.state.countryCode,
    });
    if (check) {
      if (this.props.userState.findUserforAdmin.haveAccount) {
        const roles = JSON.parse(
          this.props.userState.findUserforAdmin.dataUser.roleId
        ).roles;
        let check = false;
        roles.forEach((roleEle) => {
          if (
            roleEle.role === "ownerSpa" &&
            roleEle.serviceCode === this.state.service.no
          )
            check = true;
        });
        if (check)
          // user đang là owner của spa này
          this.setState(
            {
              modalContent:
                "Người dùng này đang là chủ của spa " + this.state.service.name,
            },
            function () {
              this.mDialogNotice.handleDialogOpen();
            }
          );
        else
          this.setState(
            {
              modalContent:
                "Grant owner rights to " +
                this.state.countryCode +
                " " +
                this.state.mobilePhone,
              agreeModal: "OK",
            },
            function () {
              this.mDialogNotice.handleDialogOpen();
            }
          );
      } else
        this.setState(
          {
            modalContent:
              this.state.countryCode +
              " " +
              this.state.mobilePhone +
              " have not registered an account on system",
            agreeModal: "",
          },
          function () {
            this.mDialogNotice.handleDialogOpen();
          }
        );
    } else {
      this.setState(
        { modalContent: "An error occured. Please try again!", agreeModal: "" },
        function () {
          this.mDialogNotice.handleDialogOpen();
        }
      );
    }
  };
  onChange(e) {
    this.setState({
      mobilePhone: e.target.value,
    });
  }
  closeModal = () => {
    this.setState({ show: false, countryCode: "+84", mobilePhone: "" });
  };
  editOwner = async () => {
    if (
      !this.props.userState.findUserforAdmin.dataUser.firstName ||
      !this.props.userState.findUserforAdmin.dataUser.lastName
    ) {
      this.mDialogNotice.handleDialogClose();
      this.props.editOwnerStatus("emptyName");
    } else {
      if (this.state.action === "edit") {
        let check = await this.props.userDispatch.removeOwnerSpa({
          serviceCode: this.state.service.no,
          oldOwnerCode: this.state.service.userCode,
          newOwnerCode: this.props.userState.findUserforAdmin.dataUser.userCode,
          newOwnerName:
            this.props.userState.findUserforAdmin.dataUser.firstName +
            this.props.userState.findUserforAdmin.dataUser.lastName,
        });
        this.mDialogNotice.handleDialogClose();
        if (check) this.props.editOwnerStatus("success");
        else this.props.editOwnerStatus("error");
      } else if (this.state.action === "add") {
        let check = await this.props.userDispatch.addOwnerSpa({
          serviceCode: this.state.service.no,
          userCode: this.props.userState.findUserforAdmin.dataUser.userCode,
          ownerName:
            this.props.userState.findUserforAdmin.dataUser.firstName +
            this.props.userState.findUserforAdmin.dataUser.lastName,
        });
        this.mDialogNotice.handleDialogClose();
        if (check) this.props.addOwnerStatus("success");
        else this.props.addOwnerStatus("error");
      }
    }
  };
  openModal = async (service, action) => {
    this.setState({ show: true, service: service, action: action });
  };
  handleCountryCode = (name, value) => {
    this.setState({ countryCode: value });
  };
  render() {
    const { classes, t } = this.props;
    return (
      <Dialog
        open={this.state.show}
        TransitionComponent={Transition}
        keepMounted
        // onClose={this.props.handleDialogEditClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        classes={{
          paperWidthSm: classes.paperWidthSm,
        }}
      >
        <DialogNotice
          onRef={(dialog) => (this.mDialogNotice = dialog)}
          openDialogs={this.state.showModal}
          disagree={t("voucher_uservoucher_cancel")}
          agree={this.state.agreeModal}
          title={t("voucher_uservoucher_notice")}
          content={this.state.modalContent}
          action={this.editOwner}
        />
        <DialogTitle
          id="scroll-dialog-title"
          disableTypography
          style={{ padding: 0 }}
        >
          {this.state.action === "add" ? (
            <Typography variant="h4" className={classes.title}>
              {" "}
              {t("Add Owner spa")}{" "}
            </Typography>
          ) : (
            <Typography variant="h4" className={classes.title}>
              {" "}
              {t("Edit Owner spa")}{" "}
            </Typography>
          )}
        </DialogTitle>
        <Grid container className={classes.gridContainer}>
          <DialogContent className={classes.content}>
            <Grid container spacing={24}>
              {/* <Grid item xs={12} sm={12}>
                                 <div className={classes.note}> {t('Enter one mobile phone and add owner spa for this service if they have registered an account')}</div>
                            </Grid> */}
              <Grid item xs={12} sm={2} className={classes.boxCountryCode}>
                <CountryCode
                  code={
                    this.state.ownerData.countryCode
                      ? this.state.ownerData.countryCode
                      : this.state.countryCode
                  }
                  handleCountryCode={this.handleCountryCode}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl className={classes.inputPhoneNumber}>
                  <Input
                    required
                    id="custom-css-standard-input"
                    disableUnderline
                    placeholder={t("voucher_uservoucher_type_phone_number")}
                    value={
                      this.state.ownerData.username
                        ? this.state.ownerData.username
                        : this.state.mobilePhone
                    }
                    onChange={(event) => this.onChange(event)}
                    // onKeyPress={this.onKeyPressPhone}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} className={classes.footer}>
                {/* <div className={classes.note}> {t('voucher_uservoucher_you_can_only_send_maximum_of_100_customers_per_submission_to_send_more_customers_upgrade_your_package_to_premium')}</div> */}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={this.findUserforAdmin}
                >
                  Find mobile phone
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Grid>

        <DialogActions classes={{ root: classes.rootDialogActions }}>
          <IconButton
            aria-label="Close"
            size="small"
            className={classes.marginCloseButton}
            onClick={this.closeModal}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  }
}

AddOwnerModal.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  userState: state.user,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  userDispatch: dispatch.user,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(AddOwnerModal)
  )
);
// export default SendVoucher
